import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: row;

  .ant-statistic-content-value {
    font-size: 18px;
    text-overflow: ellipsis;
    overflow: hidden;
    width: 100%;
  }
`;

export const IconContainer = styled.div`
  width: 65px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-content: center;
  align-self: center;
`;

export const ActionsContainer = styled.div`
  width: 32px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  align-self: center;

  svg {
    color: #57575740;
    ${Container}:not(:hover) & {
      display: none;
    }
  }
`;
